import React from 'react';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { VerifyContact } from "aws-amplify-react";
import { I18n } from '@aws-amplify/core';
import Auth from '@aws-amplify/auth';

import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import AmplifyTheme from '../../themes/AmplifyTheme';
import CssBaseline from '@material-ui/core/CssBaseline';

class CustomVerifyContact extends VerifyContact {
  constructor(props) {
    super(props);
    this._validAuthStates = ['verifyContact'];
    this.submit = this.submit.bind(this);
  }

  submit() {
    const { code } = this.inputs;
    if (!Auth || typeof Auth.verifyCurrentUserAttributeSubmit !== 'function') {
        throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
    }

    Auth.verifyCurrentUserAttribute("email");

    Auth.verifyCurrentUserAttributeSubmit("email", code)
    .then(() => {
        this.changeState('signedIn', this.props.authData);
    })
    .catch(err => this.error(err));
  }

  showComponent() {
    const { classes, authData={} } = this.props;
    return (
      <MuiThemeProvider theme={AmplifyTheme}>
        <CssBaseline />
        <div className={classes.main}>
          <Paper className={classes.paper}>
            <img src={require('../../assets/img/logo-square-on-white.svg').default} width="200" height="200" alt="QRsticker logo"/>
            <Typography component="h1" variant="h5" className={classes.title}>
              {I18n.get('Account recovery requires verified contact information')}
            </Typography>
            
             <form className={classes.form}>
              <FormControl margin="normal" required fullWidth>
                <InputLabel htmlFor="code">{I18n.get('Code')}</InputLabel>
                <Input id="code" key="code" name="code" autoComplete="code" autoFocus onChange={this.handleInputChange} />
              </FormControl>
                <Button
                  type="button"
                  fullWidth
                  variant="contained"
                  color="secondary"
                  className={classes.submit}
                  onClick={this.submit}>
                    {I18n.get('Submit')}
                </Button>
                <hr />
                <Button
                  type="button"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  onClick={() => this.changeState('signedIn', authData)}>
                    {I18n.get('Skip')}
                </Button>
              </form>
          </Paper>
        </div>
      </MuiThemeProvider>
    );
  }
}

export default withStyles(AmplifyTheme)(CustomVerifyContact);